import { Theme } from '@mui/material/styles'

export const getSXStyles = (isMobile: boolean) => ({
  centered: {
    alignItems: 'center',
    display: 'inline-flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: (theme: Theme) => theme.spacing(2),
    paddingTop: (theme: Theme) => theme.spacing(0),
    width: '100%',
  },

  container: {},

  title: {
    width: '100%',
    maxWidth: isMobile ? '504px' : '660px',
    marginBottom: '12px',
  },

  main: {
    alignContent: 'center',
    display: 'inline-flex',
    gap: 2,
    flexDirection: 'row',
  },

  scroll: {
    display: 'flex',
    maxWidth: isMobile ? '504px' : '660px',
  },

  sticky: {
    display: 'flex',
    height: '100%',
    position: 'sticky',
    top: '150px',
    overflowY: 'auto',
    transition: 'all 400ms ease-out',
    width: '368px',
    minWidth: '368px',
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0, 0, 0, 0)', // fully transparent initially
      borderRadius: '4px',
      transition: 'background-color 0.3s ease', // smooth fade
    },
    '&:hover::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)', // fade in on hover
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent',
    },

    scrollbarWidth: 'thin', // keeps space reserved
    scrollbarColor: 'transparent transparent', // transparent thumb initially
    '&:hover': {
      scrollbarColor: 'rgba(0,0,0,0.4) transparent', // thumb visible on hover
    },
  },
})
